// @ts-nocheck

// @index('./*.vue', (f, _) => `import { default as Book${_.pascal(f.name)} } from '${f.path}${f.ext}'`)
import { default as BookCommentItem } from './comment_item.vue'
import { default as BookCommentList } from './comment_list.vue'
// @endindex

export const BookCommentComponents = {
  // @index('./*.vue', (f, _) => `Book${_.pascal(f.name)},`)
  BookCommentItem,
  BookCommentList,
  // @endindex
}
